import React, { forwardRef, useEffect, useState } from 'react'
import BaseModal from '../../../components/BaseModal';
import {Form, Alert } from 'antd';
import { FieldTypes } from 'utils/formUtils';
import Vocabulary from 'components/Vocabulary';
import { generateFormFields } from 'utils/formUtils';
import ProductAPI from 'restAPI/ProductAPI';
import SubProductAPI from 'restAPI/SubProductAPI';
import SubProductEnvironmentTypeAPI from 'restAPI/SubProductEnvironmentTypeAPI';
import { MODAL_SIZE_MEDIUM } from 'constants/Layout';
import { SNOOZE_OPTIONS } from 'constants/NotificationConstants';
import AlertsAPI from 'restAPI/AlertsAPI';
import message from 'components/CustomMessage';
import  {isUndefined } from "lodash";
import moment from "moment";
import { useHasDisabledEnvironment } from 'contexts/GlobalSettingsContext';

const ProductSubproductLevelPopup = forwardRef(({toolName, configData, updateData, ...props}, ref) => {
    const [form] = Form.useForm();
    const [data, setData] = useState(getInitialData(configData));
    const isEdit = !isUndefined(configData);
    const [environments, setEnvironments] = useState([]);
    const {hasDisabledEnvironment, envValue} = useHasDisabledEnvironment();
    
    useEffect(() =>{
        if(!data.subProduct || data.subProduct === "All"){
            return;
        }
        const {promise, cancel} = SubProductEnvironmentTypeAPI.getAllQuick(data.subProduct);
        promise.then(setEnvironments);
        return cancel;
    }, [data.subProduct])
    
    const createNotification = async () => {
        await form.validateFields();
        let _environment = data.environment;
        if(hasDisabledEnvironment){
            _environment = environments.find(env => env.name === envValue)?.id;
        }
        try{
            const values = getRequestData({...data, environment: _environment}, toolName);
            await AlertsAPI[!isEdit ? "postToolScanFrequency" : "updateToolScanFrequency"](values, configData?.id).promise;
            message.success(`Successfully ${isEdit ? "updated" : "created"} notification.`);
            updateData && updateData();
        }
        catch (err) {
            return Promise.reject(err);
        }
    }

    const modalProps = {
        title: `${isEdit ? "Edit" : "Configure"} ${toolName} Settings`,
        width: MODAL_SIZE_MEDIUM,
        onOk: createNotification
    }

    const fields = [
    // {
    //     name: "title",
    //     label: "Title",
    //     colSpan: 12,
    //     required: true
    // }, {
    //     name: "description",
    //     label: "Description",
    //     type: FieldTypes.TEXT_AREA,
    //     colSpan: 24, 
    //     required: true
    // }, 
    {
        name: "product",
        label: <Vocabulary name="product" />,
        type: FieldTypes.SELECT,
        colSpan: 12,
        rules: [{required: true, message: <><Vocabulary name="product" /> is required</>}],
        props: {
            api: ProductAPI.getAllQuick,
            onChange: (e) => form.setFieldsValue({subProduct: null, environment: null})
        },
    }, {
        name: "subProduct",
        label: <Vocabulary name="subProduct" />,
        type: FieldTypes.SELECT,
        colSpan: 12,
        rules: [{required: true, message: <><Vocabulary name="subProduct" /> is required</>}],
        props: {
            api: getSubproductList,
            apiParams: data.product,
            onChange: (e) => form.setFieldsValue({environment: null})
        },
    }, ...(hasDisabledEnvironment ? [] : [{
        name: "environment",
        label: "Environment",
        type: FieldTypes.SELECT,
        colSpan: 12,
        required: true,
        options: environments
    }]), 
    // {
    //     name: "date",
    //     label: "Date",
    //     type: FieldTypes.DATE_RANGE,
    //     placeholder: ["Start date", "End date"],
    //     props: {
    //         className: "w-100",
    //     },
    //     colSpan: 12,
    //     required: true,
    // }, 
    {
        name: "interval",
        label: "Frequency for checking scans",
        type: FieldTypes.SELECT,
        options: SNOOZE_OPTIONS,
        colSpan: 12,
        required: true,
    }]

    return(
        <BaseModal
            ref={ref}
            modalProps={modalProps}
            afterClose={props.afterClose}
        >
            <Alert className="m-b-sm" message={<>Configure security tool frequency by selecting <Vocabulary name="product" isLowerCase={true} />, <Vocabulary name="subProduct" isLowerCase={true} /> and specific environment</>} type="info" />
            <Form
                initialValues={data}
                form={form}
                layout="vertical"
                onValuesChange={(_, values) => setData({...data, ...values})}
            >
                {generateFormFields(fields)}
            </Form>
        </BaseModal>
    )
})

export default ProductSubproductLevelPopup;

function getSubproductList(productId){
    if(!productId || productId === "All"){
        return Promise.resolve([]);
    } else {
        return SubProductAPI.getAllQuick(productId);
    }
}

function getRequestData(data, toolName) {
    data.toolName = toolName;
    if(data.fromDate && data.toDate) {
        data.fromDate = data.date[0]?.valueOf();
        data.toDate = data.date[1]?.valueOf();
    }
    delete data.date;
    return data;
}

function getInitialData(data = {}) {
    if(data.fromDate && data.toDate) {
    data.date = [moment(moment.utc(data.fromDate).format("YYYY-MM-DD"), "YYYY-MM-DD"), 
                moment(moment.utc(data.toDate).format("YYYY-MM-DD"), "YYYY-MM-DD")];
    }
    return data;
}